import { render, staticRenderFns } from "./PopupCodesProfile.vue?vue&type=template&id=e10de03a&"
import script from "./PopupCodesProfile.vue?vue&type=script&lang=js&"
export * from "./PopupCodesProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalWindow: require('/builds/2oYM8JSf/1/mcp/sk-soutez-2022/frontend/components/ModalWindow.vue').default})
